import React, { useEffect, useState } from "react";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar/Sidebar";
import InputField from "../../Components/UIComponents/InputField";
import Button from "../../Components/UIComponents/Button";
import Dropdown from "../Dropdown/Dropdown";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import CustomDateInput from "./CustomDateInput";
import { useLocation, useNavigate } from "react-router-dom";
import { servicePost } from "../../helper/api";
const CouponType = [
  {
    name: "One Time",
  },

  {
    name: "Expiry",
  },
];

const EditCoupon = () => {
  const [selectedStartDate, setSelectedStartDate] = useState("");
  const [selectedExpiryDate, setSelectedExpiryDate] = useState("");
  const [selectedType, setSelectedType] = useState("");

  // const [coupon, setCoupon] = useState();
  // const [amount, setAmount] = useState();
  // const [discount, setDiscount] = useState();
  // const [minDescription, setMindescription] = useState();
  // const [dicountDescription, setDiscountDescription] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const { state } = useLocation();
  const CouponDatas = state;
  const CouponData = CouponDatas.data;
  console.log("couponData", CouponData);

  // get AuthToken from localStorage
  const authToken = localStorage.getItem("token");
  const notification = "";

  const [formData, setFormData] = useState({
    coupon: "",
    amount: "",
    discount: "",
    minDescription: "",
    dicountDescription: "",
  });
  console.log("formData", formData);

  const { coupon, amount, discount, minDescription, dicountDescription } =
    formData;

  // get All InputValues
  const inputEventHandler = (event) => {
    const { name, value } = event.target;
    setFormData((oldValue) => {
      return {
        ...oldValue,
        [name]: value,
      };
    });
  };

  // if Already input Have Already Value
  useEffect(() => {
    if (CouponData) {
      setFormData({
        coupon: !CouponData.couponCode ? "" : CouponData.couponCode,
        amount: !CouponData.amount ? "" : CouponData.amount,
        discount: !CouponData.discount ? "" : CouponData.discount,
        minDescription: !CouponData.couponDescription
          ? ""
          : CouponData.couponDescription,
        dicountDescription: !CouponData.description
          ? ""
          : CouponData.description,
      });

      setSelectedType(!CouponData.couponType ? "" : CouponData.couponType);
      setSelectedStartDate(!CouponData.startDate ? "" : CouponData.startDate);
      setSelectedExpiryDate(!CouponData.endDate ? "" : CouponData.endDate);
    }
  }, [CouponData]);

  // HandleDate Change
  const handleDateChange = (date) => {
    setSelectedStartDate(date);
  };

  const handleExpiryDateChange = (date) => {
    setSelectedExpiryDate(date);
  };

  const handleDropdownChange = (field) => (value) => {
    if (field === "Type") {
      setSelectedType(value);
    }
  };

  const addCouponHandler = async () => {
    //return;
    if (
      amount == "" ||
      coupon == "" ||
      discount == "" ||
      amount == undefined ||
      coupon == undefined ||
      discount == undefined
    ) {
      setError(true);
      setErrorMessage("*please add alldata");
      return;
    }
    //setSelectedExpiryDate(data);
    let coupondata = {
      id: CouponData.id,
      discount: discount,
      amount: amount,
      startDate: selectedStartDate,
      endDate: selectedExpiryDate,
      couponType: selectedType,
      couponCode: coupon,
      description: dicountDescription,
      couponDescription: minDescription,
    };

    try {
      //console.log("infodata",infodata);
      setIsLoading(true);
      const addCoupon = await servicePost(
        "adminbooking/updateCoupon",
        coupondata,
        notification,
        authToken
      );
      console.log("addCoupon", addCoupon);

      if (addCoupon.message == "SUCCESS") {
        navigate("/coupon");
      }
    } catch (error) {
      console.log("error?.response?.data", error?.response?.data);
      const errorMessage =
        error?.response?.data?.message ||
        "An error occurred, please try again.";

      setError(true);
      setIsLoading(false);
      setErrorMessage(errorMessage);
      setTimeout(() => {
        setErrorMessage("");
        setError(false);
        setIsLoading(false);
      }, 5000);
      return;
    }
  };

  const goToCouponPage = () => {
    navigate("/coupon");
  };
  return (
    <>
      <Navbar />
      <Sidebar />
      <div className="create-coupon-main-wrapper transfer-admin-history-wrap">
        <div className="container">
          <div className="transfer-history-header">
            <img
              className="cleaner-payment-icon"
              src="./images/icons/coupon.svg"
              alt="icon"
            />
            <h3> Coupon/Edit Coupon </h3>
          </div>

          <div className="create-coupon-main-wrap">
            <div className="create-coupon-head">
              <img
                onClick={goToCouponPage}
                src="./images/icons/back-arrow.png"
                alt="icon"
              />
              <h4> Edit Coupon </h4>
            </div>

            <div className="create-coupon-inner-wrapper">
              <div className="create-coupon-inner-wrap">
                <h4> Edit Coupon</h4>
                <div className="create-coupon-fields-wrap">
                  <div className="login-option">
                    <form autoComplete="off">
                      <div className="coupon-input-fields">
                        <Dropdown
                          label="Select Type"
                          onTypeChange={handleDropdownChange("Type")}
                          data={CouponType}
                          alreadyValue={selectedType}
                        />

                        <div className="date-input-wrap">
                          <DatePicker
                            minDate={new Date()}
                            selected={selectedStartDate}
                            onChange={handleDateChange}
                            dateFormat="dd MMM yyyy" // Use consistent date format
                            customInput={
                              <CustomDateInput
                                value={
                                  selectedStartDate
                                    ? moment(selectedStartDate).format(
                                        "DD MMM YYYY"
                                      )
                                    : ""
                                }
                                lable="Start Date"
                              />
                            }
                          />
                        </div>

                        <div className="date-input-wrap">
                          <DatePicker
                            minDate={new Date()}
                            selected={selectedExpiryDate}
                            onChange={handleExpiryDateChange}
                            dateFormat="dd MMM yyyy" // Use consistent date format
                            customInput={
                              <CustomDateInput
                                value={
                                  selectedExpiryDate
                                    ? moment(selectedExpiryDate).format(
                                        "DD MMM YYYY"
                                      )
                                    : ""
                                }
                                lable="Expiry Date"
                              />
                            }
                          />
                        </div>
                      </div>
                      <div className="coupon-input-fields">
                        <InputField
                          type="text"
                          name="coupon"
                          id="couponCode"
                          label="Coupon Code"
                          passwordIcon={false}
                          onChange={inputEventHandler}
                          value={coupon}
                        />
                        <InputField
                          type="number"
                          name="amount"
                          id="amount"
                          label="Amount"
                          passwordIcon={false}
                          onChange={inputEventHandler}
                          value={amount}
                        />
                        <InputField
                          type="number"
                          name="discount"
                          id="discount"
                          label="Discount"
                          passwordIcon={false}
                          onChange={inputEventHandler}
                          value={discount}
                        />
                      </div>

                      <div className="coupon-textarea-fields">
                        <textarea
                          name="minDescription"
                          placeholder="Min. Amount Description"
                          onChange={inputEventHandler}
                          value={minDescription}
                        ></textarea>

                        <textarea
                          name="dicountDescription"
                          placeholder="Discount Description"
                          onChange={inputEventHandler}
                          value={dicountDescription}
                        ></textarea>
                      </div>
                      {error ? (
                        <div className="error-msg">{errorMessage}</div>
                      ) : (
                        ""
                      )}
                    </form>

                    <div className="create-coupon-save-button-wrapper">
                      <Button
                        label="Update"
                        onClick={addCouponHandler}
                        isLoading={isLoading}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditCoupon;
